// extracted by mini-css-extract-plugin
export default {"warningContainer":"ExternalCeremonyOverview_warningContainer__yIy7c","icon":"ExternalCeremonyOverview_icon__xZ5LQ"};